export const svgIcons: string[] = [
  'logo-text',
  'round-fire',
  'aml_drag_handler',
  'fire',
  'edit',
  'email',
  'round-success',
  'white-round-success',
  'payment-success',
  'circle-usdt',
  'incoming-transaction',
  'outcoming-transaction',
  'aml-energy-logo',
  'header-icon-aml',
  'header-icon-support',
  'header-icon-wallets',
  'header-icon-cases',
  'header-icon-team',
  'header-icon-reports',
  'header-icon-eis-dashboard',
  'header-icon-what-is-eis',
  'checkmark-circle',
  'check-mark-circle-filled',
  'icon-report',
  'clock-two',
  'clock-white-circle',
  'case',
  'lea-report-closed',
  'lea-report-permantn-closed',
  'opened-lock-icon',
  'closed-lock-icon',
  'switch-icon',
  'user-icon',
  'pouch-icon',
  'tron-icon',
  'exclamation',
  'teather-icon',
  'gear-icon',
  'tooltip-icon',
  'download-icon',
  'play-icon',
  'copy-clipboard',
  'copy-clipboard-new',
  'round-risk-low',
  'round-risk-medium',
  'round-risk-high',
  'round-risk-severe',
  'icon-warning-smart',
  'report',
  'warning',
  'warning-new',
  'settings',
  'icon-success',
  'round-usd',
  'incognito',
  'telegram-icon',
  'fire-down',
  'button-wallet',
  'close',
  'shield',
  'wallet',
  'setting-outline',
  'change-lang-icon',
  'invoice-one-day-icon',
  'round-succes-outline',
  'confirm-delete-icon',
  'risk-low',
  'risk-medium',
  'risk-high',
  'risk-severe',
  'compare-instruction',
  'api-docs',
  'logout',
  'business',
  'back-button',
  'error-circle',
  'notification-circle',
  'sad-smile',
  'circle-not-checked',
  'circle-checked',
  'arrow-right',
  'arrow-right-2',
  'arrow-right-text',
  'triangle-play',
  'icon-profile',
  'shield-bold-stroke',
  'sad-face-icon',
  'check-wallet',
  'button-back',
  'wallets',
  'edit-2',
  'edit-3',
  'round-error',
  'icon-edit',
  'icon-loading',
  'in-process-waiting',
  'check-wallet-file',
  'check-wallet-total',
  'check-wallet-ready',
  'check-wallet-warning',
  'another-user-info',
  'another-user-support',
  'btc-icon',
  'trx-icon',
  'eth-icon',
  'sol-icon',
  'bnb-icon',
  'usdc-icon',
  'ltc-icon',
  'usdt-icon',
  'usdd-icon',
  'business-account',
  'case-icon',
  'add-member-icon',
  'remove-item-icon',
  'close_new',
  'big-status-high',
  'timer-icon',
  'radio-circle',
  'icon-tg-in-square',
  'check-wallet',
  'person',
  'business-2',
  'eye',
  'error',
  'clock',
  'radio-circle',
  'radio-circle-checked',
  'lock',
  'settings-2',
  'icon-add-case',
  'telegram',
  'plus',
  'person-2',
  'incident-progress-next',
  'incident-progress-current',
  'incident-progress-success',
  'circle-radio-checked',
  'circle-radio',
  'head-of-compliance',
  'workspace',
  'agile_roles_for_uses',
  'check_pending',
  'icon-stolen',
  'slim-horizontal-arrow',
  'cursor-icon',
  'checkmark-circle-bold',
  'chili-icon',
  'infinity-icon',
  'icon-cross',
  'check-circle-white',
  'again',
  'clock-classic',
  'case-exclamation-icon',
  'check-green',
  'slim-nav-arrow',
  'slim-arrow-down',
  'slim-arrow-up',
  'thin-arrow',
  'check-marker',
  'provider-secret-sauce',
  'provider-bitok',
  'provider-global-ledger',
  'provider-beosin',
  'checkmark-circle-bold',
  'icon-check-success',
  'whatsapp',
  'telegram-color',
  'calendar',
  'icon-wallet-monitoring',
  'icon-wallet-monitoring-active',
  'icon-search-wallet',
  'icon-search-wallet-active',
  'aml-energy-logo-vector',
  'links-arrow',
  'telegram-light-blue',
  'whatsapp-new',
  'wallet-2',
  'team-icon',
  'telegram-vector',
  'code-icon',
  'support-icon',
  'icon-lock-filled',
  'gavel-filled',
  'shield-in-white-circle',
  'check-mark-in-white-circle',
  'big-status-low',
  'big-status-medium',
  'big-status-high',
  'big-status-severe',
  'send-code',
  'paper-clips-icon',
  'icon-recovery',
  'icon-permanent-freeze',
  'icon-temporary-freeze',
  'icon-status-ler-sent',
  'icon-eis-signals',
  'update-icon',
  'report-incoming',
  'report-outgoing',
  'arrow-down',
  'case-exclamation-icon',
  'slim-nav-arrow',
  'slim-arrow-down',
  'thin-arrow',
  'check-marker',
  'provider-secret-sauce',
  'provider-bitok',
  'provider-global-ledger',
  'provider-beosin',
  'check-green',
  'icon-revoke',
  'again',
  'pricing-star',
  'pricing-check-mark',
  'pricing-invoice-saved',
  'pricing-expiry-calendar',
  'pricing-expiry-clock',
  'pricing-expiry-bell',
  'pricing-expiry-alert-triangle',
  'pricing-expiry-party-popper',
  'pricing-expiry-party-stars',
  'pricing-expiry-alert-lock',
  'restore-icon',
  'vector-lock-icon',
  'vector-lock-icon-2',
  'report-2',
  'cross-vector',
  'icon-change-account',
  'attention-topup',
  'close-icon',
  'usdt-circle-vector',
  'circle-success'
];
